import React, { useEffect, useState } from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import { useDispatch } from 'react-redux';
import { genericUpdate } from '../../redux/reducers/FYSetupStep';

const EnableEInvoiceModal = ({ turnover, handleChangeGSTDetails }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (turnover > 50000000) {
      setOpen(true);
    }
  }, [turnover]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleEnable = () => {
    handleChangeGSTDetails({ target: { name: 'einvoiceflag', checked: true } });
    setOpen(false);
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          width: 400,
          p: 4,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          mx: 'auto',
          mt: '20vh',
        }}
      >
        <Typography variant="h1" fontWeight="bold" mb={2}>
          Enable E-Invoice
        </Typography>
        <Typography mb={3}>
          We noticed your previous year's turnover exceeds ₹5 crore. To ensure compliance with government regulations, we recommend enabling
          e-invoicing for your business.
        </Typography>
        <Box display="flex" justifyContent="flex-end" gap={2}>
          <Button variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="contained" onClick={handleEnable}>
            Enable
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default EnableEInvoiceModal;
